import {EMAIL_PATTERN} from "./operators.js";

export const ValidatorFns = {
    required: control => ValidatorFns._isNonEmptyString(control.value) ? null : {required: true},

    email: control => ValidatorFns._isNonEmptyString(control.value)
        ? !control.value.match(EMAIL_PATTERN) ? {email: true} : null
        : null,

    orgNumber: control => ValidatorFns._isNonEmptyString(control.value)
        ? !control.value.match(/^SE\d{10}01$/) ? {orgNumber: true} : null
        : null,

    postCode: control => ValidatorFns._isNonEmptyString(control.value)
        ? !control.value.match(/\d{5}/) ? {postCode: true} : null
        : null,

    minLength: length => control => ValidatorFns._isNonEmptyString(control.value) && control.value.length >= length
        ? null
        : {minLength: true},

    maxLength: length => control => ValidatorFns._isNonEmptyString(control.value) && control.value.length < length
        ? null
        : {maxLength: true},

    _isNonEmptyString: str => str && str.length > 0
}

export const Validator = {
    validate: (validatorData, formMsg) => formData => {
        let formValid = null;
        formData.forEach(input => {
            const inputValidators = validatorData[input.name];

            if (!inputValidators) {
                return;
            }

            const errorResponse = Validator._getValidatorErrorResponse(input, inputValidators);

            if (!errorResponse) {
                Validator._removeErrorFromInput(input);
            } else {
                input.classList.add('error');
                formValid = {...formValid, ...errorResponse};

                if (formMsg) {
                    Validator._setValidatorMsg(input, errorResponse[input.name], formMsg)
                }
            }

        });

        return formValid;
    },

    clearInputs: formData => {
        formData.forEach(input => {
            input.value = null;
            Validator._removeErrorFromInput(input);
        })
    },

    _removeErrorFromInput: input => {
        const inputName = Validator._dotNameFormatter(input.name);
        input.classList.remove('error');
        Validator._resetValidatorMsg(inputName);
    },

    _dotNameFormatter: name => {
        const _name = name.split('.');

        return _name.length > 1 ?  _name.join('-'): name;
    },

    _getValidatorErrorResponse: (input, validators) => {
        let errorObj = null;
        for (let validatorFn of validators) {
            const response = validatorFn(input);

            if (errorObj) {
                break;
            }

            if (response) {
                errorObj = {[input.name]: response};
            }
        }

        return errorObj;
    },

    _setValidatorMsg: (input, validatorObj, formMsg) => {
        const name = Validator._dotNameFormatter(input.name);
        const errorField = document.querySelectorAll(`.js-error-${name}`)[0];

        if (!errorField) {
            return;
        }

        Object.keys(validatorObj).forEach(key => {
            if (name in formMsg && key in formMsg[name]) {
                errorField.innerHTML = formMsg[name][key];
            }
        })
    },

    _resetValidatorMsg: name => {
        const errorField = document.querySelectorAll(`.js-error-${name}`)[0];

        if (!errorField) {
            return;
        }

        document.querySelectorAll(`.js-error-${name}`)[0].innerHTML = null;
    }
}
